
<!-- <ng-container *ngIf="screenWidth > 768"> -->
  <app-quote-step7-desktop [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep($event)" (onPrevStep)= "prevStep()"></app-quote-step7-desktop>
<!-- </ng-container> -->

<!-- <ng-container *ngIf="screenWidth <= 768">
  <app-quote-step7-mobile [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step7-mobile>
</ng-container> -->